const CURRENCIES = {
  INR: "₹",
};

export { CURRENCIES };
